import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m13 13.3.5.7a2.4 2.4 0 0 0 4.3-1.6L17 7.2A2.5 2.5 0 0 0 14.7 5H5.3C4.1 5 3 6 3 7.2l-.7 5.2A2.4 2.4 0 0 0 6.5 14l.5-.7zm-.8 1.7a4 4 0 0 0 7.2-2.9L18.8 7c-.3-2.1-2-3.7-4.1-3.7H5.3a4.2 4.2 0 0 0-4 3.7l-.8 5a4 4 0 0 0 7.3 3z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M6.7 6.7c-.5 0-.9.3-.9.8v.8H5A.8.8 0 1 0 5 10h.8v.8a.8.8 0 1 0 1.7 0V10h.8a.8.8 0 1 0 0-1.7h-.8v-.8c0-.5-.4-.8-.8-.8M15 8.3a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6m-1.7 3.4a.8.8 0 1 0 0-1.7.8.8 0 0 0 0 1.7" }, null, -1)
  ]))]))
}
export default { render: render }